<script lang="ts">
	import * as m from '$lib/paraglide/messages';
	import { page } from '$app/stores';

	// TOC czytany z DOM po mount — działa na prerenderowanej treści mdsvex;
	// id nagłówków zapieka rehype-slug przy buildzie, więc kotwice są realne.
	interface TocItem {
		id: string;
		text: string;
		level: 2 | 3;
	}

	let items = $state<TocItem[]>([]);

	$effect(() => {
		// Zależność od pathname — ponowny skan po nawigacji między artykułami.
		void $page.url.pathname;
		const headings = Array.from(
			document.querySelectorAll<HTMLHeadingElement>('article.wiki-article :is(h2, h3)[id]')
		);
		items = headings.map((h) => ({
			id: h.id,
			text: h.textContent ?? '',
			level: h.tagName === 'H2' ? 2 : 3
		}));
	});
</script>

{#if items.length > 1}
	<nav class="wiki-toc" aria-label={m.wiki_toc_label()}>
		<p class="wiki-toc-title">{m.wiki_toc_label()}</p>
		<ul>
			{#each items as item (item.id)}
				<li class:sub={item.level === 3}>
					<a href="#{item.id}">{item.text}</a>
				</li>
			{/each}
		</ul>
	</nav>
{/if}

<style>
	.wiki-toc-title {
		font-size: 0.72rem;
		font-weight: 700;
		letter-spacing: 0.08em;
		text-transform: uppercase;
		color: var(--v3-muted);
		margin: 0 0 0.5rem;
	}
	.wiki-toc ul {
		list-style: none;
		margin: 0;
		padding: 0;
		display: flex;
		flex-direction: column;
		gap: 0.3rem;
		border-left: 1px solid var(--v3-border);
	}
	.wiki-toc li {
		padding-left: 0.75rem;
	}
	.wiki-toc li.sub {
		padding-left: 1.5rem;
	}
	.wiki-toc a {
		color: var(--v3-muted);
		font-size: 0.82rem;
		text-decoration: none;
		display: block;
		line-height: 1.4;
	}
	.wiki-toc a:hover {
		color: var(--v3-text);
	}
</style>
